import { createContext } from "react";
import { ITlfStatusContext } from "./tlf/interface";

export const TlfContext = createContext<ITlfStatusContext | null>(null);
